import { useState } from 'react';
import EnrollmentChecksTitle from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/EnrollmentChecksTitle';
import EnrollmentChecksEmptyState from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/EnrollmentChecksEmptyState';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import EnrollmentValidationResultAccordion from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/EnrollmentValidationResultAccordion';
import usageTracker from 'flow-doctor-lib/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentChecksSection = ({
  status,
  validationChecks,
  flowRevision,
  objectId,
  timelineItem
}) => {
  const [openAccordionsByIndex, setOpenAccordionsByIndex] = useState(new Set());
  const handleOpenAccordionChange = (newOpen, index) => {
    if (newOpen) {
      usageTracker.track('pageAction', {
        actionType: 'CLICK_EXPAND_ENROLLMENT_CHECK',
        objectTypeId: flowRevision.flow.objectTypeId
      });
      openAccordionsByIndex.add(index);
    } else {
      usageTracker.track('pageAction', {
        actionType: 'CLICK_COLLAPSE_ENROLLMENT_CHECK',
        objectTypeId: flowRevision.flow.objectTypeId
      });
      openAccordionsByIndex.delete(index);
    }
    setOpenAccordionsByIndex(new Set([...openAccordionsByIndex]));
  };
  const hasValidationChecks = validationChecks.length > 0;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      justify: "between",
      children: [/*#__PURE__*/_jsx(EnrollmentChecksTitle, {
        status: status
      }), hasValidationChecks && /*#__PURE__*/_jsx(UIButton, {
        size: "xs",
        use: "tertiary-light",
        onClick: () => {
          if (openAccordionsByIndex.size === validationChecks.length) {
            usageTracker.track('pageAction', {
              actionType: 'CLICK_COLLAPSE_ALL_ENROLLMENT_CHECKS',
              objectTypeId: flowRevision.flow.objectTypeId
            });
            setOpenAccordionsByIndex(new Set());
          } else {
            usageTracker.track('pageAction', {
              actionType: 'CLICK_EXPAND_ALL_ENROLLMENT_CHECKS',
              objectTypeId: flowRevision.flow.objectTypeId
            });
            setOpenAccordionsByIndex(new Set(validationChecks.map((_, i) => i)));
          }
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: openAccordionsByIndex.size === validationChecks.length ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.enrollmentChecks.collapseAll' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.enrollmentChecks.expandAll'
        })
      })]
    }), !hasValidationChecks && /*#__PURE__*/_jsx(EnrollmentChecksEmptyState, {
      status: status,
      portalId: flowRevision.portalId,
      flowId: flowRevision.flowId,
      objectId: objectId,
      timelineItem: timelineItem
    }), validationChecks.map((validationCheck, index) => /*#__PURE__*/_jsx("div", {
      "data-test-id": "validation-result-accordion",
      children: /*#__PURE__*/_jsx(EnrollmentValidationResultAccordion, {
        open: openAccordionsByIndex.has(index),
        onOpenChange: newOpen => handleOpenAccordionChange(newOpen, index),
        flowRevision: flowRevision,
        validationResult: validationCheck,
        objectId: objectId
      })
    }, index))]
  });
};
export default EnrollmentChecksSection;